var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1964,
    height: 2066,
    viewBox: "0 0 1964 2066",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1918.18 840.084L1047.82 39.3509C1019.53 13.3196 982.265 -0.768104 943.826 0.0323331C905.387 0.83277 868.745 16.4594 841.559 43.646L41.0795 844.13L0 885.205V2065.28H771.364V1328.98H1192.11V2065.28H1963.47V881.755L1918.18 840.084ZM946.841 140.251C948.077 140.251 947.314 140.518 946.784 141.04C946.236 140.518 945.605 140.251 946.841 140.251ZM1823.23 1925.03H1332.36V1328.98C1332.36 1291.78 1317.58 1256.11 1291.28 1229.81C1264.98 1203.51 1229.3 1188.73 1192.11 1188.73H771.364C734.168 1188.73 698.496 1203.51 672.194 1229.81C645.892 1256.11 631.116 1291.78 631.116 1328.98V1925.03H140.248V943.298L946.841 142.815C946.898 142.762 946.902 142.714 946.946 142.661L1823.23 943.298V1925.03Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.c28847304787195625a431d72ae0479e.svg";
export { ForwardRef as ReactComponent };